let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fLGVd")).then(() => parcelRequire('3fhoV'));